import { httpService } from "../http";
import { User } from "./suishenxing";

const GO_MICRO = process.env.REACT_APP_GO_MICRO

// 获取随申行authcode
export const getSuiShenXingAuthCode = (): Promise<{
  code: string
}> => {
  return httpService.get("/mp2c-micro/carbon/sss/auth/code", {}, { baseURL: GO_MICRO })
}
// 判断用户是否注册碳普惠
export const getSuiShenXingAccountInfo = (): Promise<{
  isRegister: boolean; // 是否注册碳普惠
  isRealAuth: boolean; // 是否实名认证碳普惠
}> => {
  return httpService.get("/mp2c-micro/carbon/sss/account/status", {}, { baseURL: GO_MICRO });
}

// 判断用户奖励状态
export const getSuiShenXingRewardStatus = (): Promise<{
  hasPrizeQualification: boolean;
  openStatus: boolean
}> => {
  return httpService.get("/mp2c-micro/activity/sss/carbon/openaccountreward/status", {}, { baseURL: GO_MICRO });
}

// 根据token获取用户信息
export const getUserBaseInfo = (): Promise<User> => {
  return httpService.get("/mp2c-micro/user/info", {}, { baseURL: GO_MICRO });
}
